import { TableColumn } from '../../components/DataTable/TableColumn';
import { DiscountAtCheckout } from '../../interfaces/DiscountAtCheckout/DiscountAtCheckout';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { PriceColumn } from '../../components/DataTable/PriceColumn';
import { ButtonColumn } from '../../components/DataTable/ButtonColumn';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<DiscountAtCheckout>[] = [
  {
    id: 'id',
    name: 'Ürün ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'price',
    name: 'Kasa Önü Fiyatı',
    accessor: (row) => <PriceColumn value={row.price} />,
  },
];

type DiscountAtCheckoutTableProps = {
  rows: DiscountAtCheckout[];
  onClickRow: (row: DiscountAtCheckout) => void;
  onDeleteRow: (row: DiscountAtCheckout) => void;
};

export const DiscountAtCheckoutTable = (
  props: DiscountAtCheckoutTableProps,
) => {
  const deleteColumn: TableColumn<DiscountAtCheckout> = {
    id: 'delete',
    name: 'Sil',
    align: 'center',
    accessor: (row) => (
      <ButtonColumn label='Sil' onClick={() => props.onDeleteRow(row)} />
    ),
  };

  return (
    <DataTable
      columns={[...columns, deleteColumn]}
      totalCount={props.rows.length}
      rows={props.rows}
      hidePagination
      onClick={props.onClickRow}
    />
  );
};
